import { render, staticRenderFns } from "./BookNow.vue?vue&type=template&id=096f30c4&scoped=true&lang=pug&"
import script from "./BookNow.vue?vue&type=script&lang=js&"
export * from "./BookNow.vue?vue&type=script&lang=js&"
import style0 from "./BookNow.vue?vue&type=style&index=0&id=096f30c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f30c4",
  null
  
)

export default component.exports